import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { FieldProps } from '@rjsf/utils'
import { useTranslation } from 'react-i18next'
import { dashify } from 'utils/dashify'

export const CheckboxField = (props: FieldProps) => {
  const {
    fieldPathId,
    registry,
    schema,
    formData,
    uiSchema,
    onBlur,
    onChange,
    onFocus,
    ...rest
  } = props
  const { t } = useTranslation()

  const label =
    uiSchema['ui:title'] ||
    uiSchema['ui:label'] ||
    uiSchema['ui:title-translation-key']

  const translatedLabel = label
    ? t(`project:ws-${dashify(label)}`, { defaultValue: label, ns: 'project' })
    : ''

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            {...rest}
            size="small"
            checked={Boolean(formData)}
            color="secondary"
            onBlur={(e) => onBlur(fieldPathId.$id, e.target)}
            onFocus={(e) => onFocus(fieldPathId.$id, e.target)}
            onChange={(e, checked) => {
              onChange(checked, fieldPathId.path)
            }}
            data-testid={`bom-details-ws-checkbox-${dashify(label || props.id)}`}
          />
        }
        labelPlacement="top"
        label={<Typography variant="body2">{translatedLabel}</Typography>}
      />
    </>
  )
}
